import React, { memo } from 'react';
export function ThreePortals() {
  const portals = [{
    icon: '🌹',
    title: 'PORTAL 1: EL ÚTERO',
    subtitle: 'Centro de creación, poder y memorias de dolor ancestral.',
    description: 'Aquí se alojan los traumas de las mujeres que te precedieron. Los abortos no llorados, los abusos callados, los sueños enterrados por mandatos familiares. Cuando limpiás este portal, tu creatividad, tu abundancia y tu deseo vuelven a fluir naturalmente.'
  }, {
    icon: '💗',
    title: 'PORTAL 2: EL CORAZÓN Y LOS SENOS',
    subtitle: 'Centro de nutrición, entrega y recepción de amor.',
    description: 'Aquí se procesa el duelo, el abandono y la capacidad de recibir sin sentir que "no lo merecés". Cuando abrís este portal, dejás de dar desde el agotamiento y empezás a recibir desde la gracia.'
  }, {
    icon: '🎵',
    title: 'PORTAL 3: LA GARGANTA Y LA VOZ',
    subtitle: 'Espejo directo del útero. Lo que no podés decir, lo carga tu vientre.',
    description: 'Aquí se libera a través del sonido, los mantras y el decreto sagrado. Cuando activás este portal, tu voz deja de ser un instrumento de complacencia y se convierte en un instrumento de poder.'
  }];
  return <section className="py-8 px-4 bg-cream" data-id="element-316">
      <div className="max-w-5xl mx-auto" data-id="element-317">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-10 max-w-3xl mx-auto leading-tight" data-id="element-318">
          Para sanar de verdad, necesitás trabajar los 3 Portales del Cuerpo
          Femenino
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-319">
          {portals.map((portal, index) => <div key={index} className="bg-white rounded-2xl p-6 shadow-soft border border-soft-rose hover:shadow-glow transition-shadow duration-300 flex flex-col items-center text-center" data-id="element-320">
              <div className="text-4xl mb-4 bg-soft-rose w-16 h-16 rounded-full flex items-center justify-center" data-id="element-321">
                {portal.icon}
              </div>
              <h3 className="text-lg font-bold mb-2 text-warm-brown-dark" data-id="element-322">
                {portal.title}
              </h3>
              <h4 className="text-xs font-semibold text-deep-rose mb-3 uppercase tracking-wide" data-id="element-323">
                {portal.subtitle}
              </h4>
              <p className="text-sm text-warm-brown leading-relaxed" data-id="element-324">
                {portal.description}
              </p>
            </div>)}
        </div>

        <div className="mt-10 text-center max-w-3xl mx-auto space-y-4 bg-soft-rose/50 p-6 rounded-2xl" data-id="element-325">
          <h3 className="text-xl font-bold" data-id="element-326">
            Cuando los 3 portales trabajan juntos, la sanación deja de ser un
            esfuerzo y se convierte en un proceso natural de tu propio cuerpo.
          </h3>
          <p className="text-lg font-semibold text-deep-rose" data-id="element-327">
            Eso es exactamente lo que hace ALQUIMIA DEL LINAJE.
          </p>
        </div>
      </div>
    </section>;
}